import React from 'react'
import ReactDom from 'react-dom'
import update from 'immutability-helper';
import { browserHistory } from 'react-router'

import THREE from 'particlespace-graphics-engine'

import CanvasComponent from '../../components/Graphics/CanvasComponent.jsx'
import BuildingGroupsSelect from '../../components/Buildings/BuildingGroupsSelect'
import WorkOrdersBuildingList from '../../components/WorkOrders/WorkOrdersBuildingList';
import BuildingIntegrations from '../../components/Building/BuildingIntegrations';
import AddBuildingIntegrations from '../../components/Building/AddBuildingIntegrations';
import UnitedStatesSelect from '../../helpers/General/UnitedStatesSelect';
import BuildingInsights from '../../components/Building/BuildingInsights';
import BuildingSensorHistory from '../../components/Building/BuildingSensorHistory';
import BuildingSensors from '../../components/Building/BuildingSensors';
import BuildingCameras from '../../components/Building/BuildingCameras';

import { buildings } from '../../core/controllers/Buildings'
import { activeSensorsManager } from '../../core/controllers/ActiveSensorsManager'
import { buildingRenderer } from '../../core/graphic_engine/controllers/building.js'
import { user } from '../../core/controllers/user';
import { buildingStatistics } from '../../helpers/Building/BuildingStatistics'
import { buildingControllers } from '../../core/controllers/BuildingControllers'
import { activeLevelTempetureReadingsManager } from '../../core/controllers/ActiveLevelTempetureReadingsManager.js';
import PTIAccessControl from '../../components/Building/PTIAccessControl.jsx';
import PropertiesSelect from '../../components/Listings/PropertiesSelect.jsx';
import { property } from '../../core/controllers/Property';

export default class BuildingOverviewTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            updateCanvas: false,
            renderer: new THREE.CanvasRenderer(),
            data: {
                data: {
                    building_name: '',
                    property_id: 0
                },
                belongsTo: {}
            },
            selectedUnitId: 0,
            buildingID: this.props.buildingID,
            canvasID: "building-overview",
            // TODO: customize this to pull custom states
            totalSpaces: 0,
            totalVacant: 0,
            totalOccupied: 0,
            totalLateRent: 0,
            totalMaintenance: 0,
            editMode: false,
            hasIntegrations: false,
            activeOverview: 'active',
            activeSensors: '',
            activeAnalytics: '',
            hasCameras: false,
            hasAccessControl: false,
            selectedProperty: null
        }
    }

    sendHome() {
        browserHistory.push('/');
    }

    componentDidMount() {
        var self = this;
        buildings.getBuilding(this);
        buildings.getBuildingStatistics(this.state.buildingID, function(response) {
            buildingStatistics.determineStatistics(response.data, function() {
                self.setState({
                    totalSpaces: buildingStatistics.totalSpaces,
                    totalVacant: buildingStatistics.totalVacant,
                    totalLateRent: buildingStatistics.totalLateRent,
                    totalOccupied: buildingStatistics.totalOccupied,
                    totalMaintenance: buildingStatistics.totalMaintenance
                })
            });
        });
    }

    componentDidUpdate() {
        if(this.state.data != null && this.state.updateCanvas != true && this.state.data.meta_data != null) {
            buildingRenderer.create3DBuilding(this,this.state.data.meta_data.building_floor_plan_data.floor_plan_model, this.state.data.belongsTo.building_level_total, this.state.data.meta_data.level_states);
        }
        // scroll to top of view
        // TODO
        // ReactDom.findDOMNode(this).scrollIntoView();
    }

    componentWillUpdate(nextProps, nextState) {
    }

    componentWillUnmount() {
        activeSensorsManager.clearWindowTimeouts();
        activeLevelTempetureReadingsManager.clearWindowTimeouts();
        buildingControllers.clearAll();
    }

    handleNameChange(e){
        this.setState({
            data: update(this.state.data, {
                data: {
                    building_name: {$set: e.target.value
                }}}
            )
        });
    }

    handleGroupSelect(e) {
        this.setState({
            data: update(this.state.data, {
                belongsTo: {
                    building_group_id: {$set: e.target.value}
                }}
            )
        });
    }

    enterEditBuilding() {
        this.setState({
            editMode: true
        });
    }

    exitEditBuilding() {
        this.setState({
            editMode: false
        });
    }

    updateBuilding(e) {
        var self = this;
        buildings.updateBuildingData(this.state.data, function(response) {
            buildings.getBuilding(self);
        });
    }

    deleteBuilding(e) {
        buildings.deleteBuilding(this.state.data.belongsTo.building_id);
    }

    saveBuildingTemplate(e) {
        buildings.saveBuildingTemplate(this.state.data.belongsTo.building_id);
    }

    goBack() {
        buildingRenderer.clearWindowTimeouts();
        browserHistory.replace('/buildings');
    }

    toggleMenu(type) {
        if (type == 'overview') {
            this.setState({
                activeOverview: 'active',
                activeSensors: '',
                activeAnalytics: '',
                updateCanvas: false
            });
        } else if (type == 'sensors') {
            this.setState({
                activeOverview: '',
                activeSensors: 'active',
                activeAnalytics: ''
            });
        } else if (type == 'analytics') {
            this.setState({
                activeOverview: '',
                activeSensors: '',
                activeAnalytics: 'active'
            });
        }
    }

    reloadWithNewSensor() {
        this.setState({
            hasIntegrations: true
        });
    }

    reloadCameras() {
        this.setState({
            hasCameras: true
        });
    }

    handlePropertyChange(e) {
        var value = e.target.value;
        this.setState({
            data: update(this.state.data, {
                belongsTo: {
                    property_id: {$set: value
                }}}
            ),
        });
    }

    render(){
        const buildingData = this.state.data.data;
        const belongsTo = this.state.data.belongsTo;
        const editMode = this.state.editMode;
        const hasIntegrations = this.state.hasIntegrations;
        const buildingID = this.state.buildingID;
        const levelCount = belongsTo.building_level_total;
        const activeOverview = this.state.activeOverview;
        const activeSensors = this.state.activeSensors;
        const activeAnalytics = this.state.activeAnalytics;
        const hasCameras = this.state.hasCameras;
        const hasAccessControl = this.state.hasAccessControl;
        const property_id = belongsTo.property_id;
        const selectedProperty = this.state.selectedProperty;
        return (
            <div>
                <div class="row">
                    <span class="go-back go-back-left-side" onClick={this.goBack.bind(this)}><i class="icon-arrow-left"></i></span>
                </div>
                <div class="row">
                    <div class="sub-page-header-row col-md-11">
                        <div class="row">
                            <span class="sub-page-header-title">{buildingData.building_name}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12" style={{marginTop: "-10px"}}>
                        <div class="col-md-5">
                            <div class="col-md-2 col-md-offset-8">
                                <h4 onClick={this.toggleMenu.bind(this, 'overview')} class={"cross-tab-select " + activeOverview}>OVERVIEW</h4>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <h4 onClick={this.toggleMenu.bind(this, 'sensors')} class={"cross-tab-select " + activeSensors}>SENSORS</h4>
                        </div>
                        <div class="col-md-5">
                            <div class="col-md-2">
                                <h4 onClick={this.toggleMenu.bind(this, 'analytics')} class={"cross-tab-select " + activeAnalytics}>ANALYTICS</h4>
                            </div>
                        </div>
                    </div>
                </div>
                { activeOverview == 'active' && (
                <div>
                <div class="col-md-8">
                    <div class="content">
                        <div class="row">
                            <div class="col-md-12">
                                <CanvasComponent domID={this.state.canvasID} classID="" renderer={this.state.renderer} updateCanvas={this.state.updateCanvas}/>
                            </div>
                        </div>
                        <hr></hr>
                        <div class="row">
                            <BuildingInsights />
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="header">
                                        <h4 class="title">New Maintenance Requests</h4>
                                        <p class="category">See a snapshot of the latest maintenance requests</p>
                                    </div>
                                    <div class="content">
                                        <div class="row">
                                            <WorkOrdersBuildingList buildingId={this.state.buildingID} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="header">
                                <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="fa fa-building"></i></span> Building Overview</h4>
                                <p class="category"></p>
                            </div>
                            <div class="content">
                                { editMode === true ? (
                                <div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Building Name</label>
                                            <input type="text" class="form-control building-info" name="title" placeholder="Enter the building title" id="title" value={buildingData.building_name} onChange={this.handleNameChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Select a property</label>
                                            <PropertiesSelect columnSize={0} sortID={property_id} title="" onChange={this.handlePropertyChange.bind(this)} />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <button type="button" id="enter-edit-mode" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-left" autoComplete="off" onClick={this.exitEditBuilding.bind(this)}>
                                        Cancel
                                        </button>
                                    </div>
                                    <div class="col-md-6">
                                        <button type="button" id="save-building" data-loading-text="Loading..." class="btn btn-primary btn-warning btn-fill pull-left" autoComplete="off" onClick={this.updateBuilding.bind(this)}>
                                        Update Building
                                        </button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <button type="button" id="save-building-template" data-loading-text="Loading..." class="btn btn-primary btn-warning btn-fill pull-left" autoComplete="off" onClick={this.saveBuildingTemplate.bind(this)}>
                                        Save Template
                                        </button>
                                    </div>
                                    <div class="col-md-6">
                                        <button type="button" id="delete-building" data-loading-text="Loading..." class="btn btn-primary btn-danger btn-fill pull-left" autoComplete="off" onClick={this.deleteBuilding.bind(this)}>
                                        Delete Building
                                        </button>
                                    </div>
                                </div>
                                </div>
                                ) : (
                                <div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Building Name</label>
                                            <p>{buildingData.building_name}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="form-group">
                                            <label>Address</label>
                                            {selectedProperty != null ? (
                                                <p class="category">{selectedProperty.property_address}<br/>{selectedProperty.property_city} {selectedProperty.property_state}, {selectedProperty.property_zip}</p>
                                            ) : (
                                                <p></p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="col-sm-12">
                                            <button type="button" id="save-building" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-right" autoComplete="off" onClick={this.enterEditBuilding.bind(this)}>
                                            Edit Building
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                )}
                            </div>
                        </div>
                        <BuildingIntegrations hasIntegrations={hasIntegrations} buildingId={buildingID}/>
                    </div>
                </div>
                </div>
                )}
                { activeSensors && (
                    <div>
                        <div class="col-md-8">
                            <BuildingSensors hasIntegrations={hasIntegrations} buildingId={buildingID} />
                            <BuildingCameras hasCameras={hasCameras} buildingId={buildingID} />
                        </div>
                        <div class="col-md-4">
                            <AddBuildingIntegrations buildingId={buildingID} levelCount={levelCount} reload={this.reloadWithNewSensor.bind(this)} reloadCameras={this.reloadCameras.bind(this)}/>
                            <PTIAccessControl hasAccessControl={hasAccessControl} buildingId={buildingID} reload={this.reloadWithNewSensor.bind(this)}/>
                        </div>
                    </div>
                )}
                { activeAnalytics && (
                    <BuildingSensorHistory buildingId={this.state.buildingID} />
                )}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/BuildingOverview/BuildingOverview.jsx